import React from 'react'

import Button from 'components/Form/Button'
import CompetitiveImpression from '../Impression'
import { trackEvent } from 'services/analytics'
import { competitorLogo, sourceLogo } from '../assets'
import {
  Badge, Card, CardFooter, CardHeader, CardTitle, DateText, Grid, IdentityLogo,
  IdentityName, LoadMore, Meta, MetaRow, SourceLink, Summary,
} from './styled'

export default function MarketGrid({ formatDate, items, loadingMore, onLoadMore, pagination, t }) {
  return (
    <>
      <Grid aria-live="polite">
        {items.map((item, index) => (
          <CompetitiveImpression item={item} key={item.id} section={item.kind || 'market'}>
          {impressionRef => <Card ref={impressionRef}>
            <CardHeader>
              {item.kind === 'social' && sourceLogo(item.platform) ? (
                <IdentityLogo src={sourceLogo(item.platform)} alt={item.platform} />
              ) : item.competitor && competitorLogo(item.competitor) ? (
                <IdentityLogo src={competitorLogo(item.competitor)} alt={item.competitor} />
              ) : <IdentityName>{item.competitor}</IdentityName>}
              {item.kind === 'social' && item.competitor ? (
                competitorLogo(item.competitor) ? <IdentityLogo src={competitorLogo(item.competitor)} alt={item.competitor} competitor /> : <IdentityName>{item.competitor}</IdentityName>
              ) : item.role ? <Badge>{item.role.replace(/_/g, ' ')}</Badge> : null}
            </CardHeader>
            {item.title ? <CardTitle>{item.title}</CardTitle> : null}
            <MetaRow>
              {item.activityDate ? <DateText>{formatDate(item.activityDate)}</DateText> : null}
              {item.location ? <Meta>{item.location}</Meta> : null}
              {item.booth ? <Meta>{t('competitive_intelligence_market_booth')} {item.booth}</Meta> : null}
              {item.technologyType ? <Meta>{item.technologyType}</Meta> : null}
            </MetaRow>
            {item.summary ? <Summary>{item.summary}</Summary> : null}
            <CardFooter>
              {item.externalUrl ? (
                <SourceLink href={item.externalUrl} onClick={() => trackEvent('COMPETITIVE_EXTERNAL_LINK_OPENED', {
                  competitive_section: item.kind || 'market', content_type: item.kind || 'market', content_id: item.id,
                  competitor_id: item.competitor, competitive_source: item.platform, result_position: index + 1,
                })} target="_blank" rel="noopener noreferrer">
                  {item.kind === 'social' ? t('competitive_intelligence_market_view_post') : t('competitive_intelligence_research_view_source')} ↗
                </SourceLink>
              ) : null}
            </CardFooter>
          </Card>}
          </CompetitiveImpression>
        ))}
      </Grid>
      {pagination.hasMore ? (
        <LoadMore>
          <Button color="blue" outline nospace loading={loadingMore} disabled={loadingMore} onClick={onLoadMore}>
            {t('competitive_intelligence_research_load_more')}
          </Button>
        </LoadMore>
      ) : null}
    </>
  )
}
